/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RefundedbagCreateRecordParam model module.
 * @module model/RefundedbagCreateRecordParam
 * @version 1.0
 */
class RefundedbagCreateRecordParam {
    /**
     * Constructs a new <code>RefundedbagCreateRecordParam</code>.
     * @alias module:model/RefundedbagCreateRecordParam
     */
    constructor() { 
        
        RefundedbagCreateRecordParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RefundedbagCreateRecordParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RefundedbagCreateRecordParam} obj Optional instance to populate.
     * @return {module:model/RefundedbagCreateRecordParam} The populated <code>RefundedbagCreateRecordParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RefundedbagCreateRecordParam();

            if (data.hasOwnProperty('bagType')) {
                obj['bagType'] = ApiClient.convertToType(data['bagType'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} bagType
 */
RefundedbagCreateRecordParam.prototype['bagType'] = undefined;

/**
 * @member {String} date
 */
RefundedbagCreateRecordParam.prototype['date'] = undefined;

/**
 * @member {Number} quantity
 */
RefundedbagCreateRecordParam.prototype['quantity'] = undefined;

/**
 * @member {Number} userId
 */
RefundedbagCreateRecordParam.prototype['userId'] = undefined;






export default RefundedbagCreateRecordParam;

